<script>
	const defLocation=[114.171202,22.277469]
	
	export default{
	  	defLocation
	}
</script>



// WEBPACK FOOTER //
// src/components/tool/Global.vue